import { Box, Tabs, Tab } from '@mui/material';
import { useConfiguration as useConfigurationStore } from '../../../../../store/configurationStore';
import { TabErrorBadge } from '../TabErrorBadge/TabErrorBadge';
import { InstrumentTypeTabsProps } from './types';
import { ALL_UI_INSTRUMENT_TYPES } from '../../types';
import './InstrumentTypeTabs.scss';

export const InstrumentTypeTabs = ({
  activeInstrumentType,
  onInstrumentTypeChange,
}: InstrumentTypeTabsProps) => {
  const { getTabErrorCount } = useConfigurationStore();

  // Find the index of the active instrument type
  const activeIndex = ALL_UI_INSTRUMENT_TYPES.findIndex(
    type => type === activeInstrumentType
  );

  // Handle tab change
  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: number
  ): void => {
    const selectedType = ALL_UI_INSTRUMENT_TYPES[newValue];
    if (selectedType) {
      onInstrumentTypeChange(selectedType);
    }
  };

  return (
    <Box className="instrumentTypeTabs">
      <Tabs
        value={activeIndex !== -1 ? activeIndex : false}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {ALL_UI_INSTRUMENT_TYPES.map(type => {
          const errorCount = getTabErrorCount(type);
          return (
            <Tab
              key={type}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <span>{type}</span>
                  {errorCount > 0 && <TabErrorBadge errorCount={errorCount} />}
                </Box>
              }
            />
          );
        })}
      </Tabs>
    </Box>
  );
};
